/// <amd-module name="Agile/Board/Badge/Services" />
export * from "Agile/Board/Badge/Models/BoardBadgeInfo";
export * from "Agile/Board/Badge/Services/BoardBadgeService";
